import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { EquipmentDetailService } from './equipment-detail.service';
// import { EquipmentUpdateStatusService } from './equipment-update-status.service';

import { DialogHelper, ExceptionHelper, UserStorage } from './../../../../helper';
import { Equipment } from '../../../../model';
import * as $ from 'jquery';

@Component({
  selector: 'app-equipment-detail',
  templateUrl: './equipment-detail.component.html'
})
export class EquipmentDetailComponent implements OnInit {
  @ViewChild('warningModal') warningModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  id = '';
  model = new Equipment();
  jobData: any;

  jobs: any[];
  dataTable: any;
  isRedirect = false;

  selectedJob;

  constructor(
    private userStorage: UserStorage,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private equipmentDetailService: EquipmentDetailService,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.getDetail();
    this.getJobSummary();
  }

  getDetail() {
    this.equipmentDetailService
      .getDetail(this.id)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
            this.model.formodel = data.model;
          }
        },
        err => {
          $('.card').hide();
          this.isRedirect = true;
          this.exception.showError(err, 'showDanModalBtn');
        }
      );
  }

  getJobSummary() {
    this.equipmentDetailService
      .getJobSummary(this.id)
      .subscribe(
        data => {
          if ($.fn.dataTable.isDataTable('#jobDataTables')) { $('#jobDataTables').DataTable().destroy(); }
          this.jobs = data.equipmentByIdListModel;
          this.chRef.detectChanges();

          const table: any = $('#jobDataTables');
          this.dataTable = table.DataTable({
            autoWidth: true,
            scrollX: true
          });
        },
        error => {
          this.isRedirect = true;
          this.exception.showError(error, 'showDanModalBtn');
        }
      );
  }

  onSelect(job): void {
    this.selectedJob = job;
    // this.router.navigate(['/home/equipment/detail/' + this.id]);
    this.getJobDetail();
  }

  getJobDetail() {
    this.equipmentDetailService
      .getJobDetail(this.id, this.selectedJob.jobId)
      .subscribe(
        data => {
          if (data) {
            this.jobData = data;
          }
        },
        err => {
          $('.card').hide();
          this.isRedirect = true;
          this.exception.showError(err, 'showDanModalBtn');
        }
      );
  }

  reset() {
    this.selectedJob = null;
    this.jobData = null;
    this.getJobSummary();
  }

  errorClose() {
    if(this.isRedirect)
      this.router.navigate(['/home/equipment']);
    else {
      this.dangerModal.hide();
    }
  }

  deactivate() {
    this.warningModal.hide();

    this.equipmentDetailService.updateStatus(this.id).subscribe(data => {

      this.dialog.showModal('showWarnModalBtn');     
      this.chRef.detectChanges();
      this.router.navigate(['home','equipment','summary']);
    },
    error => {
      this.isRedirect = false;
      this.exception.showError(error, 'showDanModalBtn');
      
    });

  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-detail/equipment-detail.component.ts